<template>
  <div>
    <h2>Upload files</h2>
    <input type="file" @change="onFileChange" multiple>
    <button @click="upload">Upload</button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      files: null
    }
  },
  methods: {
    onFileChange(e) {
      this.files = e.target.files;
    },
    upload() {
      const formData = new FormData();
      for(let i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        formData.append('files[' + i + ']', file);
      }
      axios.post('/api/upload', formData);
    }
  }
}
</script>
